export const showSubCategoriesInQandA = false;
export const showEmptyCategoriesInQandA = false;
export const minLettersForSearch = 3;
export const qAndAAccentColor = "@accentRed";
// export const qAndAAccentColorFaqAccordion = "@accentLightBlue";
export const qAndAAccentColorFaqAccordion = "@middleLightGrey";


export const showCategoryLimitButton = false;
export const allowOpenMultipleAccordions = false;
export const showToTopButton = true;


export const showNewStartShowcaseStage = false;
export const showNewQandAMenuGroup = true;                        // true: Q&As aus views/QandA/QandAModels, ab zwei Einträgen im Menü als Gruppe, false: nur Q&A Cayenne Electric wie bisher
export const showUnpublishedQandAInMenu = false;
/**
 * Darstellung der Fragenliste in der Benutzeransicht.
 * "current": vom Kunden abgenommen. Alle Kategorien offen, beim Start werden alle Fragen übersetzt und alle Bewertungen geladen.
 * "recommended": Vorschlag. Kategorien zugeklappt mit Fragenzahl. Übersetzung erst beim Aufklappen, Bewertung erst beim Öffnen der Frage.
 */
// export const qAndAListMode: "current" | "recommended" = "current";
export const qAndAListMode: "current" | "recommended" = "current";

export interface NumById {
    [key: string]: number;
}

export const PERSONAL_ASSIST_KEYS = {
    HELLO: 'hello',
    THANK_YOU: 'thankYou',
    SORRY: 'sorry',
    NEW_QUESTION: 'newQuestion',
};

export const personalAssistImages = {
    [PERSONAL_ASSIST_KEYS.HELLO]: "https://cdn.imaginarity.com/public/images/faq/pARobotHello.png",
    [PERSONAL_ASSIST_KEYS.THANK_YOU]: "https://cdn.imaginarity.com/public/images/faq/pARobotThankU.png",
    [PERSONAL_ASSIST_KEYS.SORRY]: "https://cdn.imaginarity.com/public/images/faq/pARobotSorry.png",
    [PERSONAL_ASSIST_KEYS.NEW_QUESTION]: "https://cdn.imaginarity.com/public/images/faq/pARobotNewQ.png"
};

export const personalAssistTexts = {
    [PERSONAL_ASSIST_KEYS.HELLO]: "I am an international Q&A platform - initially exclusively for the new Cayenne Electric. The answers are answered manually in Zuffenhausen by Product Training. Later I will get AI. Thanks for your patience.",
    [PERSONAL_ASSIST_KEYS.THANK_YOU]: "I'm glad that my answer has helped you! I'm very pleased and would be grateful if you could give me some brief feedback.",
    [PERSONAL_ASSIST_KEYS.SORRY]: "I'm sorry that my answer didn't help you. I would like to improve - would you like to give me feedback on what I can do better?",
    [PERSONAL_ASSIST_KEYS.NEW_QUESTION]: "Can't find a suitable question for your problem? No problem! Just send us your question - including a comment and a suggestion for the right category.",
};

export const getPersonalAssistKey = (isFeedback: boolean, isPositive: boolean | undefined, isInteractionRow: boolean): string => {
    if (isFeedback) {
        return isPositive ? PERSONAL_ASSIST_KEYS.THANK_YOU : PERSONAL_ASSIST_KEYS.HELLO;
    }
    return isInteractionRow ? PERSONAL_ASSIST_KEYS.NEW_QUESTION : PERSONAL_ASSIST_KEYS.HELLO;
};


export const getColorByPercent = (percent: number): string => {
    const interpolateColor = (start: number, end: number, factor: number) =>
        Math.round(start + (end - start) * factor);

    const redStart = 149, greenStart = 0, blueStart = 20; // Red: "#950014"
    const redMid = 147, greenMid = 145, blueMid = 0; // Yellow: "#939100"
    const redEnd = 1, greenEnd = 147, blueEnd = 0; // Green: "#019300"

    let red, green, blue;

    if (percent < 50) {
        const factor = percent / 50; // Interpolate between Red and Yellow
        red = interpolateColor(redStart, redMid, factor);
        green = interpolateColor(greenStart, greenMid, factor);
        blue = interpolateColor(blueStart, blueMid, factor);
    } else {
        const factor = (percent - 50) / 50; // Interpolate between Yellow and Green
        red = interpolateColor(redMid, redEnd, factor);
        green = interpolateColor(greenMid, greenEnd, factor);
        blue = interpolateColor(blueMid, blueEnd, factor);
    }

    return `rgb(${red}, ${green}, ${blue})`;
};

export const calculateVoteData = (helpfulVotes: number, notHelpfulVotes: number, getColorByPercent: (percent: number) => string) => {
    const totalVotes = helpfulVotes + notHelpfulVotes;
    const calcedPercent = totalVotes === 0 ? 0 : Math.round((helpfulVotes / totalVotes) * 100);
    const color = getColorByPercent(calcedPercent);
    return { color };
};
